/**
 * Check if the resolution is for a mobile device.
 * @param {int} getCalculate - get checkboc group
 */
function calculateItemsInCarousel(getCalculate) {
    if (getCalculate > 1200) {
        if ($('.carousel-item-pdp').length < 5 && $(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "none";
            $(".in-carousel-maxmin")[1].style.display = "none";
        } else if ($(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "block";
            $(".in-carousel-maxmin")[1].style.display = "block";
        }
    } else if (getCalculate < 1200 && getCalculate > 992) {
        if ($('.carousel-item-pdp').length < 5 && $(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "none";
            $(".in-carousel-maxmin")[1].style.display = "none";
        } else if ($(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "block";
            $(".in-carousel-maxmin")[1].style.display = "block";
        }
    } else if (getCalculate < 992 && getCalculate > 768) {
        if ($('.carousel-item-pdp').length < 4 && $(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "none";
            $(".in-carousel-maxmin")[1].style.display = "none";
        } else if ($(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "block";
            $(".in-carousel-maxmin")[1].style.display = "block";
        }
    } else if (getCalculate < 768) {
        if ($('.carousel-item-pdp').length < 2 && $(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "none";
            $(".in-carousel-maxmin")[1].style.display = "none";
        } else if ($(".in-carousel-maxmin").length > 0) {
            $(".in-carousel-maxmin")[0].style.display = "block";
            $(".in-carousel-maxmin")[1].style.display = "block";
        }
    }
}

/**
 * Adapta altura de contenedor de nombre de todos los producto del carrusel al del contenido mas alto.
 */
function calculateHeightNameCarousel() {
    var newheightMin = 0;
    var h = 0;
    $(".pd-carousel-item-nameInter").height(20);

    $(".pd-carousel-item-nameInter").each(function() {
        h = $(this).removeAttr("style").height();

        if (h > newheightMin )  {
            newheightMin = h;
        }
    });

    $(".pd-carousel-item-nameInter").height(newheightMin);
}

/**
 * Mostrar / ocultar carrusel de productos recomendados dependiendo resolucion
 * @param {int} wScreen - Ancho de pantalla
 */
function showRecommendendProductsCaroues(wScreen) {
    // Mostrar carrusel solo en mobile
    if (wScreen < 1200 && !$(".product-recommended-mobile").hasClass("active")) {
        $('.products-carrousel-js').appendTo('.product-recommended-mobile');
        $('.product-recommended-mobile').addClass("active");
        $(".product-recommended-desktop").empty().removeClass("active");
    }

    // Mostrar carrusel solo en Desktop
    if (wScreen >= 1200 && !$(".product-recommended-desktop").hasClass("active")) {
        $('.products-carrousel-js').appendTo('.product-recommended-desktop');
        $('.product-recommended-desktop').addClass("active");
        $(".product-recommended-mobile").empty().removeClass("active");
    }

    calculateHeightNameCarousel()
}


$(window).on('load',function () {
    calculateHeightNameCarousel();

    // Mostrar solo un carrusel de productos recomendados dependiendo la resolucion
    var wScreen = $(window).width();
    if (wScreen < 1200) {
        $(".product-recommended-mobile").addClass("active");
        $(".product-recommended-desktop").empty();
    } else {
        $(".product-recommended-desktop").addClass("active");
        $(".product-recommended-mobile").empty();
    }
    // FIN -------

    $('.experience-custom_layouts-productCarousel .carousel, #carousel-custom').on('slide.bs.carousel', function (e) {
        var thisEl = $(this);
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 4;
        var carouselIner = thisEl.find('.carousel-inner')
        var totalItems = thisEl.find('.carousel-item').length;

        if (idx >= totalItems - (itemsPerSlide - 1)) {
            var it = itemsPerSlide - (totalItems - idx);
            for (var i = 0; i < it; i++) {
                // append slides to end
                if (e.direction == "left") {
                    thisEl.find('.carousel-item').eq(i).appendTo(carouselIner);
                } else {
                    thisEl.find('.carousel-item').eq(0).appendTo(carouselIner);
                }
            }
        }
    });

    calculateItemsInCarousel($(window).width());
    let diagramRefacciones = $('.descargable-item[data-id="diagramaRefacciones"]');
    let downloadBtn = $('.refacciones-descarga');
    if (diagramRefacciones && diagramRefacciones.length > 0 && downloadBtn) {
        let diagramaHref = diagramRefacciones.attr('href');
        downloadBtn.attr('href', diagramaHref).removeClass('d-none');
    }
})

$(window).resize(function() {
    if(this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function() {
        $(this).trigger('resizeEnd');
    }, 100);
});

$(window).bind("resizeEnd", function() {
    calculateHeightNameCarousel();

    // Mostrar solo un carrusel de productos recomendados dependiendo la resolucion
    var wScreen = $(window).width();
    showRecommendendProductsCaroues(wScreen);

    var calculateWidth = $(window).width();
    calculateItemsInCarousel(calculateWidth);
});